import 'construct-style-sheets-polyfill'; // THIS HAS TO BE THE FIRST IMPORT FOR FIREFOX TO WORK CORRECTLY
import { combineLatest } from 'rxjs';

import { AdornisRouter } from '@adornis/base/client/a-router';
import { BaseQLClient } from '@adornis/baseql/client/baseqlClient';
import { QueryCache } from '@adornis/baseql/client/requestHandlers/queryCache';
import '@adornis/germanium';
import { loginAfterValidation } from '@adornis/users/client/loginAfterValidation';
import 'db';
import { WTGUser } from 'db/wtg-user';
import './initRouter';
import './main-element';
import { updateNodeBBCookie } from './nodebb-token-auth';

loginAfterValidation();

// Setup BaseQL Client
const transportHandler = BaseQLClient.createTransportHandler();
const queryCache = new QueryCache(transportHandler);
BaseQLClient.initHandler(queryCache);

WTGUser.subscribeCurrentUser();

combineLatest([WTGUser.currentUser, AdornisRouter.get().path]).subscribe(([user, path]) => {
  if (user && !(user as WTGUser).hasOnboarded && !path.startsWith('/create_profile'))
    AdornisRouter.goTo('/create_profile/name');

  updateNodeBBCookie();
});

AdornisRouter.get().setDefaultMetaDesc({ title: 'Welcome-To-Germany', path: '*', description: '' });
